var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.atts
    ? _c(
        "div",
        { staticClass: "rexer_events__container" },
        [
          _c("filter-component", {
            attrs: {
              filters: _vm.filters,
              title: _vm.atts.title,
              selection: _vm.catidSelection,
              locations: _vm.locations,
              "locations-selection": _vm.currentLocationFilter.label
            }
          }),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "rexer_events__loading" },
                  [
                    _c("loading-component", {
                      attrs: { "fill-color": "#00ff00" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.loading
              ? _c(
                  "div",
                  [
                    _c("content-component", {
                      attrs: {
                        events: _vm.eventsFiltered,
                        notfound: _vm.atts.notfound
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }